import React, {h, Component} from 'preact';
import {connect} from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import store from "../store";
import MenuObject from "../canvas/menu-object";
import util from '../util';

export default @connect(reduce, actions)
class AsideMenuObjectTop extends Component {
    constructor() {
        super();
    }

    onClick() {
        if (this.props.onClick) {
            this.props.onClick();
        } else {
            store.dispatch(actions.setIsMobileAside(false));
        }
    }

    importItem() {
        store.dispatch(actions.setIsDataLibraryModal(true));
    }

    addNewItem() {
        MenuObject.moAddItem();
    }

    render(props, state) {
        const style = {
            position: "absolute",
            left: `${window.innerWidth / 2}px`,
            top: `${-60}px`,
            bottom: `20px`,
            color: "black",
            fontSize: "13px",
            whiteSpace: "nowrap",
            fontWeight: "bold",
            willChange: "transform",
            transform: "translate(-50%, 0px)",
        };
        return (
            <div className={`aside-mo-top ${props.onlyBar ? 'only-bar' : ''}`}>
                {!props.onlyBar && <div className="mo-options" style={style}>
                    <div className="mo-option hint--bottom add" data-hint="Add new item" onClick={this.addNewItem}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
                            <path fill="#333"
                                  d="M14.784 5h-1.57c-.139 0-.209.07-.209.21v8.214H5.21c-.14 0-.209.07-.209.21v1.57c0 .139.07.209.21.209h7.795v8.215c0 .14.07.21.21.21h1.57c.139 0 .209-.07.209-.21v-8.215h7.797c.14 0 .209-.07.209-.21v-1.57c0-.139-.07-.209-.21-.209h-7.796V5.21c0-.14-.07-.209-.21-.209z"></path>
                        </svg>
                    </div>
                    <div className="mo-option hint--bottom import" data-hint="Import item" onClick={this.importItem}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
                            <path fill="#333"
                                  d="M23.473 19.571h-1.307a.19.19 0 00-.188.19v1.53h-15.3V5.71h15.303v1.528c0 .104.085.19.187.19h1.307a.189.189 0 00.187-.19V4.76a.752.752 0 00-.746-.76H5.746A.751.751 0 005 4.76v17.48c0 .421.333.76.746.76h17.168a.751.751 0 00.746-.76v-2.478a.189.189 0 00-.187-.19zm.333-6.962h-7.63v-1.88c0-.166-.189-.26-.315-.156l-3.448 2.771a.198.198 0 00-.075.156.201.201 0 00.075.156l3.448 2.77c.128.105.316.01.316-.155v-1.88h7.629a.197.197 0 00.194-.198v-1.386a.197.197 0 00-.194-.198z"></path>
                        </svg>
                    </div>
                </div>}
                <div className={'bar'} onClick={this.onClick.bind(this)}/>
            </div>
        )
    }
}
